import { createTheme, Loader, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import type { ReactNode } from 'react';
import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router';

import type { Route } from './+types/root';
import BotChatWidget from './components/shared/bot-chat-widget';
import './lib/dayjs-config';
import './styles/globals.css';
import { ModalProvider } from './store/contexts/modal-context';

const mantineTheme = createTheme({});

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>GE Appliances For Business Portal</title>
        <Meta />
        <Links />
      </head>
      <body>
        <MantineProvider forceColorScheme="light" theme={mantineTheme}>
          <Notifications />
          {children}
        </MantineProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
};

export const HydrateFallback = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <Loader type="bars" />
    </div>
  );
};

export const ErrorBoundary = ({ error }: Route.ErrorBoundaryProps) => {
  if (
    import.meta.env.MODE === 'development' ||
    import.meta.env.MODE === 'staging'
  ) {
    console.error(error);
  }

  if (
    typeof error === 'object' &&
    error &&
    'status' in error &&
    (error.status === 401 || error.status === 403)
  ) {
    return null;
  }

  return (
    <section className="flex h-screen w-screen items-center justify-center">
      <p>Something went wrong!</p>
    </section>
  );
};

const App = () => {
  return (
    <ModalProvider>
      <Outlet />
      <BotChatWidget />
    </ModalProvider>
  );
};

export default App;
